import React from "react";
import { C, text } from "../theme";

// One date control for the whole app (UX-27), bound to a YYYY-MM-DD string
// value. It is the browser's native <input type="date">: the picker, the
// locale display format (dd/mm/yyyy for en-SG) and strict parsing of typed
// input (UX-56) all come from the platform, so no date library ships to the
// client. Health-sweep step 5: react-datepicker + date-fns + floating-ui were
// ~44% of the bundle for this one control.

const inputStyle = {
  width: "100%", padding: 8, border: `1px solid ${C.gray300}`, borderRadius: 6,
  fontSize: text.md, fontFamily: "inherit", boxSizing: "border-box",
  background: C.white, color: C.gray1100,
};

// Today's date (YYYY-MM-DD) in Singapore.
export const todaySG = () => new Date(Date.now() + 8 * 3600 * 1000).toISOString().slice(0, 10);

// Local-date <-> YYYY-MM-DD helpers (no timezone drift). Kept for callers that
// need Date objects; DateField itself works on the string form.
export const parseYMD = (s) => {
  if (!s) return null;
  const [y, m, d] = s.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const toYMDLocal = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// A YYYY-MM-DD prefix or "" — native date inputs reject anything else, and the
// stored value may carry a time part from the API.
const toInputValue = (v) => (v ? String(v).slice(0, 10) : "");

export default function DateField({ value, onChange, disabled, id, minDate = "today" }) {
  const min = minDate === "today" ? todaySG() : minDate ? toInputValue(minDate) : undefined;
  return (
    <input
      type="date"
      id={id}
      value={toInputValue(value)}
      min={min}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value || "")}
      style={inputStyle}
    />
  );
}
